import React from "react";
import AppStoreBadge from "../components/AppStoreBadge";

const appStoreUrl = "https://apps.apple.com/fr/app/velis-productivity/id6792467812";
const buildFestUrl = "https://app.emergent.sh/showcase/builderfest-kevin/5c91a570-7f35-46a9-befb-695f099afec4";

const screenshots = [
  {
    src: "/images/home-screen-updated.png",
    alt: "Accueil de VÉLIS avec les priorités du jour",
    eyebrow: "Priorités du jour",
    title: "Choisissez ce qui compte vraiment.",
  },
  {
    src: "/images/missions-screen-updated.png",
    alt: "Missions dans VÉLIS",
    eyebrow: "Missions",
    title: "Mettez vos actions au bon endroit.",
  },
  {
    src: "/images/expeditions-screen-updated.png",
    alt: "Expéditions dans VÉLIS",
    eyebrow: "Expéditions",
    title: "Voyez votre progression prendre forme.",
  },
];

const BuildFest = () => {
  return (
    <main className="min-h-screen bg-velis-dark text-white">
      <section className="relative overflow-hidden border-b border-white/10 px-6 py-20 sm:px-10 lg:px-16">
        <div className="absolute left-1/2 top-0 h-80 w-80 -translate-x-1/2 rounded-full bg-velis-orange/20 blur-3xl" />
        <div className="relative mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-[1.05fr_0.95fr]">
          <div>
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.34em] text-velis-orange">
              Build Fest Emergent
            </p>
            <h1 className="max-w-3xl text-5xl font-bold leading-tight sm:text-6xl lg:text-7xl">
              Soutenez VÉLIS au Build Fest.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-white/72 sm:text-xl">
              VÉLIS transforme vos missions quotidiennes en progression visible. Essayez l’app gratuitement sur l’App Store, puis votez si elle vous aide à garder le cap.
            </p>
            <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
              <AppStoreBadge url={appStoreUrl} height={54} />
              <a
                href={buildFestUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex min-h-[54px] items-center justify-center rounded-xl border border-velis-orange bg-velis-orange px-6 text-base font-bold text-black transition hover:bg-velis-orange/90"
              >
                Voter au Build Fest
              </a>
            </div>
            <p className="mt-4 max-w-xl text-sm text-white/55">
              Le vote se fait sur Emergent et peut nécessiter un compte gratuit.
            </p>
          </div>

          <div className="relative mx-auto w-full max-w-[360px] lg:max-w-[410px]">
            <div className="absolute inset-8 rounded-[42px] bg-velis-orange/18 blur-3xl" />
            <img
              src="/images/home-screen-updated.png"
              alt="VÉLIS sur iPhone"
              className="relative w-full rounded-[38px] border border-white/10 shadow-2xl shadow-black/50"
            />
          </div>
        </div>
      </section>

      <section className="px-6 py-16 sm:px-10 lg:px-16">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-3xl">
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-velis-orange">
              Pourquoi VÉLIS
            </p>
            <h2 className="mt-4 text-3xl font-bold leading-tight sm:text-5xl">
              Une autre façon de voir la productivité.
            </h2>
            <p className="mt-5 text-lg leading-8 text-white/68">
              Vous aurez toujours des choses à faire. L’important, c’est de choisir celles qui font réellement avancer vos objectifs.
            </p>
          </div>

          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {screenshots.map((item) => (
              <article key={item.src} className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04]">
                <div className="aspect-[9/12] overflow-hidden bg-black">
                  <img src={item.src} alt={item.alt} className="h-full w-full object-cover object-top" />
                </div>
                <div className="p-6">
                  <p className="text-xs font-semibold uppercase tracking-[0.24em] text-velis-orange">
                    {item.eyebrow}
                  </p>
                  <h3 className="mt-3 text-xl font-bold leading-snug">{item.title}</h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="px-6 pb-20 sm:px-10 lg:px-16">
        <div className="mx-auto max-w-5xl rounded-[32px] border border-white/10 bg-gradient-to-br from-white/[0.08] to-white/[0.03] p-8 text-center sm:p-12">
          <img src="/images/velis-compass-round.png" alt="Boussole VÉLIS" className="mx-auto h-20 w-20 rounded-3xl" />
          <h2 className="mt-7 text-3xl font-bold sm:text-5xl">Essayez VÉLIS. Soutenez le projet.</h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-white/68">
            Si l’expérience vous parle, votre vote peut aider VÉLIS à avancer au Build Fest Emergent.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <AppStoreBadge url={appStoreUrl} height={50} />
            <a
              href={buildFestUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-[50px] items-center justify-center rounded-xl border border-white/18 px-6 text-base font-bold text-white transition hover:border-velis-orange hover:text-velis-orange"
            >
              <img src="/images/codex-clipboard-57e4f224-2e2f-42b8-9f50-2c836c960d2d.png" alt="Finaliste Build Fest" className="mr-2 h-12 w-12 object-contain" />Soutenir VÉLIS au Build Fest
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BuildFest;
